__turbopack_context__.v({
  "error": "payment-step-module-scss-module__iP2coW__error",
  "methods": "payment-step-module-scss-module__iP2coW__methods",
  "pay": "payment-step-module-scss-module__iP2coW__pay",
  "root": "payment-step-module-scss-module__iP2coW__root",
  "title": "payment-step-module-scss-module__iP2coW__title",
});
